import { LayoutDirection } from '@crema/constants/AppEnums';
import defaultConfig, { defaultTheme } from '@crema/constants/defaultConfig';
import PropTypes from 'prop-types';
import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from 'react';

const ThemeContext = createContext({
    theme: defaultTheme.theme,
    themeStyle: defaultConfig.themeStyle,
    themeMode: defaultConfig.themeMode,
});
const ThemeActionsContext = createContext();

export const useThemeContext = () => useContext(ThemeContext);

export const useThemeActionsContext = () => useContext(ThemeActionsContext);

const ThemeContextProvider = ({ children }) => {
    const [theme, setTheme] = useState(defaultTheme.theme);
    const [themeMode, setThemeMode] = useState(defaultConfig.themeMode);
    const [themeStyle, setThemeStyle] = useState(defaultConfig.themeStyle);

    const updateTheme = useCallback((theme) => {
        setTheme(theme);
    }, []);

    useEffect(() => {
        if (theme.direction === LayoutDirection.RTL) {
            document.body.setAttribute('dir', LayoutDirection.RTL);
        } else {
            document.body.setAttribute('dir', LayoutDirection.LTR);
        }
    }, [theme]);

    const values = useMemo(
        () => ({
            theme,
            themeStyle,
            themeMode,
        }),
        [theme, themeStyle, themeMode],
    );

    const actions = useMemo(
        () => ({
            updateTheme,
            setThemeStyle,
            setThemeMode,
        }),
        [updateTheme, setThemeStyle, setThemeMode],
    );

    return (
        <ThemeContext.Provider value={values}>
            <ThemeActionsContext.Provider value={actions}>
                {children}
            </ThemeActionsContext.Provider>
        </ThemeContext.Provider>
    );
};

export default ThemeContextProvider;

ThemeContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
